var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "flex flex-wrap filter_blocks" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Период отчета")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-group" },
              [
                _c("DateSelect", {
                  ref: "dateFrom",
                  attrs: { selectedDate: _vm.preset.date.from },
                }),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("DateSelect", {
                  ref: "dateTo",
                  attrs: { selectedDate: _vm.preset.date.to },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group flex-grow-1" }, [
            _c("label", [_vm._v('Причина отмены через ","')]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter.rejectWords,
                  expression: "filter.rejectWords",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.filter.rejectWords },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.filter, "rejectWords", $event.target.value)
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mt-1" }, [
          _c("div", [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter.groupBy,
                    expression: "filter.groupBy",
                  },
                ],
                attrs: { type: "radio", value: "none" },
                domProps: { checked: _vm._q(_vm.filter.groupBy, "none") },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.filter, "groupBy", "none")
                  },
                },
              }),
              _vm._v(" не группировать"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter.groupBy,
                    expression: "filter.groupBy",
                  },
                ],
                attrs: { type: "radio", value: "city" },
                domProps: { checked: _vm._q(_vm.filter.groupBy, "city") },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.filter, "groupBy", "city")
                  },
                },
              }),
              _vm._v(" группировать по городам"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter.groupBy,
                    expression: "filter.groupBy",
                  },
                ],
                attrs: { type: "radio", value: "drug" },
                domProps: { checked: _vm._q(_vm.filter.groupBy, "drug") },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.filter, "groupBy", "drug")
                  },
                },
              }),
              _vm._v(" группировать по препарату"),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex filter_blocks justify-content-between" },
          [
            _c("div", { staticClass: "flex filter_blocks" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v("Города")]),
                  _vm._v(" "),
                  _c(
                    "multiselect",
                    {
                      attrs: {
                        options: _vm.$AllCities,
                        placeholder: "Выберите города",
                        "track-by": "id",
                        label: "short_name",
                        searchable: true,
                        multiple: true,
                      },
                      on: { input: (t) => {} },
                      model: {
                        value: _vm.filter.selectedCities,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "selectedCities", $$v)
                        },
                        expression: "filter.selectedCities",
                      },
                    },
                    [
                      _c("template", { slot: "noResult" }, [
                        _vm._v("Город не найден"),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v("Игнорировать города")]),
                  _vm._v(" "),
                  _c(
                    "multiselect",
                    {
                      attrs: {
                        options: _vm.$AllCities,
                        placeholder: "Выберите города",
                        "track-by": "id",
                        label: "short_name",
                        searchable: true,
                        multiple: true,
                      },
                      on: { input: (t) => {} },
                      model: {
                        value: _vm.filter.ignoredCities,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "ignoredCities", $$v)
                        },
                        expression: "filter.ignoredCities",
                      },
                    },
                    [
                      _c("template", { slot: "noResult" }, [
                        _vm._v("Город не найден"),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v("Типы отмены")]),
                  _vm._v(" "),
                  _c(
                    "multiselect",
                    {
                      attrs: {
                        options: _vm.$platformConstants.orderRejectReasons,
                        placeholder: "Выберите причину",
                        "track-by": "id",
                        label: "title",
                        searchable: true,
                        multiple: true,
                      },
                      on: { input: (t) => {} },
                      model: {
                        value: _vm.filter.reject_types,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "reject_types", $$v)
                        },
                        expression: "filter.reject_types",
                      },
                    },
                    [
                      _c("template", { slot: "noResult" }, [
                        _vm._v("Причина не найдена"),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "align-self-end" },
              [
                _c("LoadingButton", {
                  attrs: {
                    title: "Показать",
                    type: "button",
                    loading: _vm.loading,
                    color: _vm.$constants.LOADING_COLOR,
                    onClick: () => _vm.getRecords(1),
                    className: "btn btn-outline-info",
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.records !== null
      ? _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _vm.paginator
                ? _c(
                    "div",
                    { staticClass: "flex justify-content-between" },
                    [
                      _c("span", [
                        _vm._v("Всего записей: "),
                        _c("strong", [_vm._v(_vm._s(_vm.paginator.total))]),
                      ]),
                      _vm._v(" "),
                      _c("paginate", {
                        attrs: {
                          "page-count": _vm.paginator.last_page,
                          "page-range": 8,
                          "margin-pages": 2,
                          "click-handler": _vm.getRecords,
                          "prev-text": "&laquo",
                          "next-text": "&raquo",
                          "container-class": "pagination",
                          "prev-class": "page-item",
                          "prev-link-class": "page-link",
                          "page-class": "page-item",
                          "page-link-class": "page-link",
                          "next-class": "page-item",
                          "next-link-class": "page-link",
                          "active-class": "active green_btn",
                        },
                        model: {
                          value: _vm.paginator.current_page,
                          callback: function ($$v) {
                            _vm.$set(_vm.paginator, "current_page", $$v)
                          },
                          expression: "paginator.current_page",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("pulse-loader", {
                staticClass: "text-center",
                attrs: {
                  loading: _vm.loading,
                  color: _vm.$constants.LOADING_COLOR,
                },
              }),
              _vm._v(" "),
              !_vm.loading
                ? [
                    _c(
                      "table",
                      {
                        staticClass:
                          "table table-sm mt-1 table-hover table-striped",
                      },
                      [
                        _vm.selectedType === "drug"
                          ? [
                              _vm._m(1),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.records, function (r, i) {
                                  return _c("tr", { key: r.id }, [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          i +
                                            1 +
                                            (_vm.paginator.current_page - 1) *
                                              _vm.paginator.per_page
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(r.drug_id) +
                                          ") " +
                                          _vm._s(r.drug_title)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(r.total))]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(Math.round(r.total_drugs))),
                                    ]),
                                  ])
                                }),
                                0
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedType === "city"
                          ? [
                              _vm._m(2),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                [
                                  _vm._l(_vm.records, function (rr, cityId, i) {
                                    return rr.length
                                      ? [
                                          _c("tr", [
                                            _c(
                                              "td",
                                              {
                                                attrs: {
                                                  rowspan: rr.length + 1,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getCityName(cityId)
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.sortRecords(rr, "total_drugs"),
                                            function (r, ii) {
                                              return _c("tr", { key: r.id }, [
                                                _c("td", [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(r.drug_id) +
                                                      ") " +
                                                      _vm._s(r.drug_title)
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      Math.round(r.total_drugs)
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  [
                                                    _c("scale-loader", {
                                                      attrs: {
                                                        loading:
                                                          _vm.storeLoading,
                                                        height: "12px",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    !_vm.storeLoading
                                                      ? [
                                                          _c("p", [
                                                            _vm._v(
                                                              "на складе: "
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.printStoreData(
                                                                    r.drug_id,
                                                                    cityId,
                                                                    "store"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("p", [
                                                            _vm._v("на мск: "),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.printStoreData(
                                                                    r.drug_id,
                                                                    cityId,
                                                                    "top"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("p", [
                                                            _vm._v(
                                                              "продажа за 30 дней: "
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .soldData?.[
                                                                    r.drug_id
                                                                  ]?.[cityId] ??
                                                                    0
                                                                )
                                                              ),
                                                            ]),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("p", [
                                                            _vm._v(
                                                              "достаточно на :\n                      "
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  Math.round(
                                                                    (+_vm.printStoreData(
                                                                      r.drug_id,
                                                                      cityId,
                                                                      "top"
                                                                    ) *
                                                                      30) /
                                                                      (_vm
                                                                        .soldData?.[
                                                                        r
                                                                          .drug_id
                                                                      ]?.[
                                                                        cityId
                                                                      ] ?? 1)
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              "\n                      дней"
                                                            ),
                                                          ]),
                                                        ]
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                ),
                                              ])
                                            }
                                          ),
                                        ]
                                      : _vm._e()
                                  }),
                                ],
                                2
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedType === "none"
                          ? [
                              _vm._m(3),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.records, function (r, i) {
                                  return _c("tr", { key: r.id }, [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          i +
                                            1 +
                                            (_vm.paginator.current_page - 1) *
                                              _vm.paginator.per_page
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("div", { staticClass: "flex" }, [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-xs btn-info mr-1",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openOrderInModal(
                                                  r.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-eye",
                                            }),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(r.id) +
                                            "\n                "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      _vm._l(r.details, function (d) {
                                        return _c("p", [
                                          _vm._v(
                                            "(" +
                                              _vm._s(d.drug_id) +
                                              ") " +
                                              _vm._s(d.drug.title) +
                                              " x "
                                          ),
                                          _c("strong", [_vm._v(_vm._s(d.qty))]),
                                          _vm._v(" x\n                  "),
                                          _c("strong", [
                                            _vm._v(_vm._s(d.price)),
                                          ]),
                                        ])
                                      }),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(r.reject_comment)),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("strong", [_vm._v(_vm._s(r.price))]),
                                    ]),
                                  ])
                                }),
                                0
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "input-group-prepend input-group-append" },
      [_c("span", { staticClass: "input-group-text" }, [_vm._v("по")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("td"),
        _vm._v(" "),
        _c("td", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("td", [_vm._v("Заявок")]),
        _vm._v(" "),
        _c("td", [_vm._v("Кол.")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Город")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Кол.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Склад")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("td"),
        _vm._v(" "),
        _c("td", [_vm._v("Заявка")]),
        _vm._v(" "),
        _c("td", [_vm._v("Препараты")]),
        _vm._v(" "),
        _c("td", [_vm._v("Отмена")]),
        _vm._v(" "),
        _c("td", [_vm._v("Сумма")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }